<section class="cta-section">
  <div class="cta-card">
    <div class="cta-content">
      <h2>Go viral in the real world</h2>
      <p>Mailed postcards starting at $0.85 + service fee</p>
      <div class="cta-button-wrapper">
        <a [routerLink]="appUrl" class="cta-button">
          Get Started
        </a>
      </div>
    </div>
  </div>
</section>
